module.exports = __webpack_public_path__ + "img/product-coca.b22da134.png";